module.exports = __webpack_public_path__ + "static/media/location-007bff.3e479180.svg";